

var validations = {
  isPositveIntegerNumber: function (string) {
    if(string ){
      return  (/^[1-9]\d*$/.test(string))
    }
    return true;
  },
   
  isAlphabet:function(string){
      if(string){
   
      // return (/^[A-Za-z]+$/.test(string))
      return (/^[a-zA-Z ]*$/.test(string))
      
     }
     return true;
},



};






export default validations;